// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useContext, useRef} from 'react';
import {useTranslation, Trans} from 'react-i18next';
import styles from './experience_block.module.less';
// @ts-ignore
import {use_expand_animation} from './use_expand_animation';
import {img_url} from './img_url';
import cn from 'classnames';
import {Button} from '../../../shared/button';
import {Settings_context} from '../settings_ctx';

interface i_experience_block {
    title?: string|JSX.Element;
    items?: {key:string, img?:string}[];
    alt_postfix?: string;
    btn_color?: 'white'|'transparent'|'gray'|'black'|'red'|'rainbow';
    need_btn?: boolean;
    pref?: string;
    cls?: string;
    shown?: string;
}
const default_items = [{key: 'no_limits'}, {key: 'safe'},
    {key: 'fastest.2'}];
export const Experience_block = ({title, items = default_items,
    alt_postfix, cls, btn_color, need_btn, pref, shown}
    :i_experience_block)=>{
    const {theme} = useContext(Settings_context);
    const {t} = useTranslation() as any;
    const r = useRef();
    const refs = items.map(()=>useRef());
    const shown_ = shown ||
        use_expand_animation(r, refs, {min_width: 1200});
    return <div className={cn(styles.wrapper, cls)}>
      <div className={cn(theme.container, styles.data, shown_ && styles.shown)}
        ref={r}>
        {title || <h2><Trans>A <span className={theme.primary}>Premium</span>
          {' '}Experience</Trans></h2>}
        <div className={styles.premium_list}>
            {items.map(({key, img}, i)=>{
                img = img || key.replace(/\..*$/, '');
                img = /\.(svg|png)$/.test(img) ? img : `plus/${img}.svg`;
                const title_block = t('premium_exp.'+key+'.title');
                return <div className={styles.premium} key={i} ref={refs[i]}>
                  <div className={styles.img_container}>
                      <img src={img_url(img)} className="lazyload"
                      alt={`${title_block} ${alt_postfix||''}`}/>
                  </div>
                  <h3>{t('premium_exp.'+key+'.title')}</h3>
                  <p>
                    <Trans i18nKey={`premium_exp.${key}.text`}
                      components={{span: <span/>}}/>
                  </p>
                </div>;
            })}
        </div>
        {need_btn && <Button cls={styles.premium_exp_button} size={'lg'}
          color={btn_color} caption={'Get Hola'} round arrow
          to={`/premium?ref=${pref}_experience`}/>}
      </div>
    </div>;
};
